module.exports = __webpack_public_path__ + "static/media/9.c4523e69.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/9.svg
// module id = 132
// module chunks = 0